// extracted by mini-css-extract-plugin
module.exports = {"matchGalleryHeader":"MatchGallery_matchGalleryHeader__6rGZY","matchGalleryItemsCount":"MatchGallery_matchGalleryItemsCount__d1Q1k"};